// extracted by mini-css-extract-plugin
module.exports = {"container":"styles-module__container___sAxIf","header":"styles-module__header___1xDCH","subText":"styles-module__subText___1Sn9x","button":"styles-module__button___3lKGH"};